import React, { useState } from "react";
import {
  ChevronDownIcon,
  UserIcon,
} from "../../../../helper/HwIcon";
import HwPlainSelect from "../../../../component/HwPlainSelect";
import DatePicker from "react-datepicker";
import { countryWithDialCode } from "../../../../helper/CountryWithDialCode";
import HwSelect from "../../../../component/HwSelect";

const typeMap = {
  adults: "Adult",
  childs: "Child",
};
export const HotelGuestDetailsForm = (props) => {
  const [open, setOpen] = useState(!!props.defaultOpen);
  const countryWithDialCodeArr = countryWithDialCode();
  const countryData =
    countryWithDialCodeArr?.map?.((items) => ({
      value: items.country_code,
      label: items.country_name,
    })) ?? [];
  const values = props.values;

  if (values?.roomInfoValues?.length <= 0) {
    return null;
  }

  if (props.preview) {
    const collapsible = props.collapsible;
    const showBody = !collapsible || open;
    const totalGuests = (values?.roomInfoValues ?? []).reduce(
      (acc, r) => acc + (r?.adults?.length ?? 0) + (r?.childs?.length ?? 0),
      0
    );
    return (
      <div className="hw-passenger--listShow__widget hw-hotel--reviewGuests">
        <div
          className={`hw-exchk--sectionHead ${collapsible ? "hw-exchk--sectionHead__toggle" : ""} ${showBody ? "is-open" : ""}`}
          onClick={collapsible ? () => setOpen((v) => !v) : undefined}
          role={collapsible ? "button" : undefined}
        >
          <span className="hw-exchk--sectionIcon"><UserIcon /></span>
          <span className="hw-exchk--sectionTitle">Guest Details</span>
          {collapsible ? (
            <span className="hw-exchk--sectionToggle">
              {totalGuests ? (
                <span className="hw-exchk--sectionMeta">
                  {totalGuests} {totalGuests > 1 ? "Guests" : "Guest"}
                </span>
              ) : null}
              <span className="hw-exchk--sectionChevron"><ChevronDownIcon /></span>
            </span>
          ) : null}
        </div>
        {showBody ? (
          <div className="hw-hotel--reviewBody">
            {values?.roomInfoValues?.map?.((roomInfoValue, i) => {
              const guests = [
                ...(roomInfoValue?.adults ?? []).map((d) => ({ ...d, _t: "Adult" })),
                ...(roomInfoValue?.childs ?? []).map((d) => ({ ...d, _t: "Child" })),
              ];
              return (
                <div className="hw-hotel--reviewRoomCard" key={i}>
                  <div className="hw-hotel--reviewRoomHead">
                    <span className="hw-hotel--reviewRoomBadge">Room {i + 1}</span>
                    <span className="hw-hotel--reviewRoomCount">{guests?.length} {guests?.length > 1 ? "Guests" : "Guest"}</span>
                  </div>
                  <ul className="hw-hotel--reviewList">
                    {guests?.map?.((d, gi) => {
                      return (
                        <li className="hw-hotel--reviewGuest" key={gi}>
                          {/* <span className="hw-hotel--reviewGuestIcon">
                            <UserIcon />
                          </span> */}
                          <span className="hw-hotel--reviewGuestName">
                            {d?.title} {d?.firstName} {d?.lastName}
                          </span>
                          <span className="hw-hotel--reviewGuestType">{d?._t}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="hw-passenger--listShow__widget hw-hotelPassenger--listShow__widget">
      <div className="hw-exchk--sectionHead">
        <span className="hw-exchk--sectionIcon"><UserIcon /></span>
        <span className="hw-exchk--sectionTitle">Guest Details</span>
      </div>
      {values?.roomInfoValues?.map((roomInfoValue, roomIndex) => {
    return (
      <div className="hw-hotel--guestRoom" key={roomIndex}>
        <div className="hw-blue hw-text18 hw-fontBold hw-hotel--guestRoomTitle">
          Room {roomIndex + 1}
        </div>
        {roomInfoValue?.adults?.map((adult, index) => {
          return (
            <HotelGuestDetailsFormItem
              {...props}
              countryData={countryData}
              roomIndex={roomIndex}
              index={index}
              values={adult}
              type={"adults"}
              errors={
                props.errors?.roomInfoValues?.[roomIndex]?.["adults"]?.[index]
              }
              touched={
                props.touched?.roomInfoValues?.[roomIndex]?.["adults"]?.[index]
              }
            />
          );
        })}
        {roomInfoValue?.childs?.map((child, index) => {
          return (
            <HotelGuestDetailsFormItem
              {...props}
              countryData={countryData}
              roomIndex={roomIndex}
              index={index}
              values={child}
              type={"childs"}
              errors={
                props.errors?.roomInfoValues?.[roomIndex]?.["childs"]?.[index]
              }
              touched={
                props.touched?.roomInfoValues?.[roomIndex]?.["childs"]?.[index]
              }
            />
          );
        })}
      </div>
    );
  })}
    </div>
  );
};

export const HotelGuestDetailsFormItem = ({
  setFieldValue = () => null,
  values = {},
  errors = {},
  touched = {},
  countryData = [],
  roomIndex,
  index,
  type,
}) => {
  const [open, setOpen] = useState(true);
  const _setFieldValue = (key, val) => {
    setFieldValue(
      `roomInfoValues[${roomIndex}][${type}][${index}][${key}]`,
      val
    );
  };

  return (
    <div className="hw-passenger--detailsGroup">
      <div
        className={`hw-passenger--detailsGroupItem fare-toggle-parent ${
          open ? "active" : ""
        }`}
      >
        <div
          onClick={() => {
            setOpen(!open);
          }}
          className="d-flex align-items-center justify-between hw-passenger--fareShowToggle"
        >
          <span className="d-flex align-items-center hw-gapy10 hw-black hw-text14 hw-fontBold">
            {typeMap?.[type] ?? type} {index + 1}
          </span>
          <span className={`hw-passenger--toggleChevron ${open ? "is-open" : ""}`}>
            <ChevronDownIcon />
          </span>
        </div>
        {open ? (
          <div className="hw-passenger--fareShowToggleContent">
            <div className="row">
              <div className="col-sm-4 col-xl-3">
                <HwPlainSelect
                  value={values?.gender || ""}
                  placeholder="Gender*"
                  options={
                    type === "adults"
                      ? [
                          { value: "Male", label: "Male" },
                          { value: "Female", label: "Female" },
                        ]
                      : [
                          { value: "Ms", label: "Ms" },
                          { value: "Master", label: "Master" },
                        ]
                  }
                  onChange={(val) => _setFieldValue("gender", val)}
                  error={touched?.gender && errors?.gender}
                />
                {touched?.gender && errors?.gender ? (
                  <p className="hw-p-error-cls">{errors?.gender}</p>
                ) : (
                  ""
                )}
              </div>
              <div className="col-sm-4 col-xl-4">
                <input
                  value={values.firstName || ""}
                  placeholder="First Name*"
                  id="fname"
                  className="hw-form--input"
                  onChange={(event) => {
                    _setFieldValue(`firstName`, event.target.value);
                  }}
                />
                {touched?.firstName && errors?.firstName ? (
                  <p className="hw-p-error-cls">{errors?.firstName}</p>
                ) : (
                  ""
                )}
              </div>
              <div className="col-sm-4 col-xl-5">
                <input
                  value={values?.lastName || ""}
                  placeholder="Last Name*"
                  id="lname"
                  className="hw-form--input"
                  onChange={(event) => {
                    _setFieldValue(`lastName`, event.target.value);
                  }}
                />
                {touched?.lastName && errors?.lastName ? (
                  <p className="hw-p-error-cls">{errors?.lastName}</p>
                ) : (
                  ""
                )}
              </div>
            </div>
            {!values?.passportRequired &&
              (values?.passengerType === "CHILD" ||
                values?.passengerType === "INFANT") && (
                <div className="row">
                  <div className="col-md-4">
                    <DatePicker
                      selected={values?.dateOfBirth}
                      onChange={(date) => {
                        _setFieldValue(`dateOfBirth`, date);
                      }}
                      isClearable
                      clearButtonClassName="hw--clear-button-date-picker"
                      placeholderText="Date Of Birth*"
                      dateFormat="dd/MM/yyyy"
                      maxDate={new Date()}
                      className={`hw-form--input ${
                        errors?.dateOfBirth ? "hw--error-cls-date-input" : ""
                      }`}
                    />
                    {errors?.dateOfBirth ? (
                      <p className="hw-p-error-cls">{errors?.dateOfBirth}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )}
            {values?.passportRequired && (
              <>
                <div className="hw-blue hw-text18 hw-fontBold">
                  Passport Details
                </div>
                <div className="row">
                  <div className="col-md-6 hw-inner--fullWidth">
                    {countryData?.length && (
                      <HwSelect
                        placeholder="Nationality*"
                        options={countryData}
                        onChangeFn={(selected) => {
                          _setFieldValue(`selectedCountryOption`, selected);
                          _setFieldValue(`countryInput`, "");
                        }}
                        value={values?.selectedCountryOption}
                        menuChnageFn={(value) => {}}
                        onInputChangeFn={(value) => {
                          _setFieldValue(`countryInput`, value);
                        }}
                        loading={false}
                        inputValue={values?.countryInput}
                        menuOpen={values?.countryInputOpen}
                        isMulti={false}
                        type={"country"}
                        isError={errors?.selectedCountryOption}
                      />
                    )}
                    {errors?.selectedCountryOption ? (
                      <p className="hw-p-error-cls">
                        {errors?.selectedCountryOption}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-6">
                    <input
                      placeholder="Passport Number*"
                      id="passport-number"
                      className="hw-form--input"
                      value={values?.passportNumber}
                      onChange={(event) => {
                        _setFieldValue(`passportNumber`, event.target.value);
                      }}
                    />
                    {touched?.passportNumber && errors?.passportNumber ? (
                      <p className="hw-p-error-cls">{errors?.passportNumber}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <DatePicker
                      selected={values?.passportIssueDate}
                      onChange={(date) => {
                        _setFieldValue(`passportIssueDate`, date);
                      }}
                      isClearable
                      clearButtonClassName="hw--clear-button-date-picker"
                      placeholderText="Passport Issue Date*"
                      dateFormat="dd/MM/yyyy"
                      className={`hw-form--input ${
                        errors?.passportIssueDate
                          ? "hw--error-cls-date-input"
                          : ""
                      }`}
                      maxDate={new Date()}
                    />
                    {touched?.passportIssueDate && errors?.passportIssueDate ? (
                      <p className="hw-p-error-cls">
                        {errors?.passportIssueDate}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-4">
                    <DatePicker
                      selected={values?.passportExpiryDate}
                      onChange={(date) => {
                        _setFieldValue(`passportExpiryDate`, date);
                      }}
                      isClearable
                      clearButtonClassName="hw--clear-button-date-picker"
                      placeholderText="Passport Expiry Date*"
                      dateFormat="dd/MM/yyyy"
                      className={`hw-form--input ${
                        errors?.passportExpiryDate
                          ? "hw--error-cls-date-input"
                          : ""
                      }`}
                      minDate={
                        new Date(new Date().setMonth(new Date().getMonth() + 6))
                      }
                    />
                    {touched?.passportExpiryDate &&
                    errors?.passportExpiryDate ? (
                      <p className="hw-p-error-cls">
                        {errors?.passportExpiryDate}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-md-4">
                    <DatePicker
                      selected={values?.passportDOB}
                      onChange={(date) => {
                        _setFieldValue(`passportDOB`, date);
                      }}
                      isClearable
                      clearButtonClassName="hw--clear-button-date-picker"
                      placeholderText="Date Of Birth*"
                      dateFormat="dd/MM/yyyy"
                      maxDate={new Date()}
                      className={`hw-form--input ${
                        errors?.passportDOB ? "hw--error-cls-date-input" : ""
                      }`}
                    />
                    {touched?.passportDOB && errors?.passportDOB ? (
                      <p className="hw-p-error-cls">{errors?.passportDOB}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};
